import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  constructor(private http: HttpClient) { }

  getCampaigns() {
     return this.http.get<any>(environment.apiUrl + 'Email/GetCampaigns');
  }

  addCampaign(campaignData: any) {  
     return this.http.post<any>(environment.apiUrl + 'Email/AddCampaign', campaignData);
  }

  getCampaignsForMember(memberId: number) {
     return this.http.get<any>(environment.apiUrl + 'Email/GetCampaignsForMemberAsync/' + memberId);
  }
 
  getFailedMails(campaignId: string) {
     return this.http.get<any>(environment.apiUrl + 'Email/GetFailedMailsAsync/' + campaignId);
  }

  getCampaignsList() {
     return this.http.get<any>(environment.apiUrl + 'Email/GetCampaignsList');
  }
  GetMonthlyStatistics() {
     return this.http.get<any>(environment.apiUrl + 'Email/GetMonthlyStatistics');
  }
}